'use strict'
import axios from 'axios'
import { cacheAdapterEnhancer, throttleAdapterEnhancer } from 'axios-extensions'

const http = axios.create({
    baseURL: '/',
    headers: { 'Cache-Control': 'no-cache' },
    adapter: throttleAdapterEnhancer(cacheAdapterEnhancer(axios.defaults.adapter))
})

export default class Api {

     getManufacturersGroupedByType () {
        return http.get('/api/v1/product-types/manufacturers')
    }

     getManufacturerModels (manufacturerId) {
        return http.get('/api/v1/models?manufacturer_id=' + manufacturerId)
    }

     getModel (modelId) {
        return http.get('/api/v1/models/' + modelId)
    }

}

